import { InjectionToken } from "@angular/core";

type LabelValues<T extends string> = Partial<Record<T, string | number>>;

export interface MetricsClient {
	startTimer(labels?: LabelValues<string>): (labels?: LabelValues<string>) => number;
}

export const METRICS_CLIENT_HTTP = new InjectionToken<MetricsClient>("Metrics Client");
